import { GridCustomCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';

export class SpeedCell extends React.Component<GridCustomCellProps> {
  public render() {
    return (
      <td {...this.props.tdProps}>
        {this.props.dataItem.DeadHeadMiles} / {this.props.dataItem.LoadedMiles} mi<br />
        {this.props.dataItem.ETAMiles} mi<br />
        {this.props.dataItem.MinutesLate > 0 && <span style={{ color: 'red' }}>
          Late: {this.props.dataItem.MinutesLate} min.<br />
        </span>}
        {this.props.dataItem.TimeCriticalMinutes > 0 && <span style={{ color: 'red' }}>
          Critical: {this.props.dataItem.TimeCriticalMinutes} min.<br />
        </span>}
        {this.props.dataItem.RequiredSpeed > 0 && <span>({this.props.dataItem.RequiredSpeed} mph)</span>}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    if (nextProps.dataItem.Hash === this.props.dataItem.Hash) {
      return false;
    }

    return true;
  }
}
